import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/pages/index/IndexPage.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/LoginPage.vue'),
    meta: { guest: true },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/dashboard/DashboardPage.vue'),
    meta: { auth: true },
  },
  {
    path: '/health',
    name: 'health',
    component: () => import('@/pages/health/HealthPage.vue'),
    meta: { auth: true },
  },
  {
    path: '/medication',
    name: 'medication',
    component: () => import('@/pages/medication/MedicationPage.vue'),
    meta: { auth: true },
  },
  {
    path: '/sos',
    name: 'sos',
    component: () => import('@/pages/sos/SosPage.vue'),
    meta: { auth: true },
  },
  {
    path: '/family',
    name: 'family',
    component: () => import('@/pages/family/FamilyPage.vue'),
    meta: { auth: true },
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('@/pages/article/ArticlePage.vue'),
    meta: { auth: true },
  },
  {
    path: '/checkin',
    name: 'checkin',
    component: () => import('@/pages/checkin/CheckinPage.vue'),
    meta: { auth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/pages/settings/SettingsPage.vue'),
    meta: { auth: true },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/pages/about/AboutPage.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/pages/privacy/PrivacyPage.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/pages/terms/TermsPage.vue'),
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/pages/feedback/FeedbackPage.vue'),
  },
  {
    path: '/verify/:token',
    name: 'verify',
    component: () => import('@/pages/verify/VerifyPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: () => import('@/pages/notfound/NotFoundPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()
  const isAuthenticated = userStore.isAuthenticated

  if (to.meta.auth && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else if (to.meta.guest && isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

export default router
